import { GenderType } from "../../models/profile/profile.model";
import { birthdayToAge } from "../../utils/profile.util";
var AVATAR_COLORS = {
    woman: { ring: '#D56E9B', fill: '#FBE9F1', ink: '#A23D6C', badge: '#B4497B' },
    girl: { ring: '#EFAAC5', fill: '#FDF0F5', ink: '#A23D6C', badge: '#B4497B' },
    man: { ring: '#4E82D4', fill: '#E7EFFB', ink: '#2F64B8', badge: '#2F64B8' },
    boy: { ring: '#9EC3F0', fill: '#EEF5FD', ink: '#2F64B8', badge: '#2F64B8' },
    other: { ring: '#828EA6', fill: '#EEF0F4', ink: '#4B5568', badge: '#5F6B82' },
};
export var getProfileAvatarColors = function (profile) {
    var _a;
    var isChild = !!(profile === null || profile === void 0 ? void 0 : profile.birthDay) && birthdayToAge(profile.birthDay) < 18;
    switch ((_a = profile === null || profile === void 0 ? void 0 : profile.gender) === null || _a === void 0 ? void 0 : _a.toUpperCase()) {
        case GenderType.FEMALE:
            return isChild ? AVATAR_COLORS.girl : AVATAR_COLORS.woman;
        case GenderType.MALE:
            return isChild ? AVATAR_COLORS.boy : AVATAR_COLORS.man;
        default:
            return AVATAR_COLORS.other;
    }
};
export var getCompletedStays = function (profile) {
    var _a, _b, _c, _d, _e, _f;
    return (_f = (_e = (_d = (_a = profile === null || profile === void 0 ? void 0 : profile.completedStaysNo) !== null && _a !== void 0 ? _a : (_c = (_b = profile === null || profile === void 0 ? void 0 : profile.smartData) === null || _b === void 0 ? void 0 : _b.stays) === null || _c === void 0 ? void 0 : _c.totalStays) !== null && _d !== void 0 ? _d : profile === null || profile === void 0 ? void 0 : profile.allStaysNo) !== null && _e !== void 0 ? _e : profile === null || profile === void 0 ? void 0 : profile.guestDialogStaysNo) !== null && _f !== void 0 ? _f : 0;
};
export var getInitials = function (profile) { return [profile === null || profile === void 0 ? void 0 : profile.firstName, profile === null || profile === void 0 ? void 0 : profile.lastName]
    .map(function (name) { var _a; return (_a = name === null || name === void 0 ? void 0 : name.trim().charAt(0)) !== null && _a !== void 0 ? _a : ''; })
    .join('')
    .toUpperCase() || '?'; };
export var getDisplayName = function (profile) { return [profile === null || profile === void 0 ? void 0 : profile.academicTitle, profile === null || profile === void 0 ? void 0 : profile.firstName, profile === null || profile === void 0 ? void 0 : profile.lastName]
    .map(function (part) { return part === null || part === void 0 ? void 0 : part.trim(); })
    .filter(Boolean)
    .join(' ') || (profile === null || profile === void 0 ? void 0 : profile.nameOrdered) || '-'; };
